import React, { useMemo } from 'react'
import { useLocation, useNavigation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import Forbidden from '@/pages/Forbidden'
import useGlobalStore from '@/store/useGlobalStore'
import Loading from '@/pages/other/Loading'
// import { getAuthPathByCodes } from '@/utils/help'
import { getStorage } from '@/utils/tools'

const ProtectedRoute = ({ children, style }: any) => {
  const location = useLocation()
  const { authorized, } = useGlobalStore()
  const { codes, getAuthPathByCodes, hasAuth } = useAuth()
  // const authListItem = useGlobalStore.getState().authListItem

  const testDocDetailDataAuth = () => {
    const authListItem = useGlobalStore.getState().authListItem
    if (!authListItem) return false;
    const authDetail = hasAuth('630:doc:prep:proj:view', authListItem.createUser)
    return authDetail
  }
  const authPaths = useMemo(() => getAuthPathByCodes(codes), [codes.length])

  // data auth
  const currentPathName = location.pathname
  if (currentPathName.includes('/document/engList/detail') && testDocDetailDataAuth()) {
    // console.log("currentPathName", currentPathName, authListItem)
    return children
  }

  // console.log("currentPathName", currentPathName)
  if (!authorized) {
    return <Loading />
  }
  if (authPaths.includes(currentPathName)) {
    return children
  }
  return <Forbidden style={style} />
}

export default ProtectedRoute
